<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container" data-simplebar>
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>{{$router.currentRoute.meta.title}}</h3>
                    </div>
                      

                    <!-- Row -->
                    <div class="row">
                        <form method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off">

                            <!-- Dashboard Box -->
                            <div class="col-xl-12">
                                <div class="dashboard-box margin-top-0">

                                    <!-- Headline -->
                                    <div class="headline">
                                        <h3><i class="material-icons">info</i> Informações gerais</h3>
                                    </div>

                                    <div class="content with-padding padding-bottom-0">

                                        <div class="row">

                                            <div class="col-xl-6 col-md-9 col-lg-9">
                                                <div class="submit-field">
                                                    <h5>Nome:</h5>
                                                    <input type="text" class="with-border" placeholder="Informe o nome..." v-model="form.nome">
                                                </div>
                                            </div>

                                            <div class="col-xl-6 col-md-8 col-lg-8">
                                                <div class="submit-field">
                                                    <h5>E-mail:</h5>
                                                    <input type="email" class="with-border" placeholder="Informe o e-mail aqui" v-model="form.email">
                                                </div>
                                            </div>

                                            <div class="col-xl-3 col-xs-8 col-md-4 col-lg-4">
                                                <div class="submit-field">
                                                    <h5>Telefone:</h5>
                                                    <the-mask :mask="['(##) #####-####','(##) ####-####']"  type="tel" class="with-border" placeholder="(__) _____-____" v-model="form.telefone" />
                                                </div>
                                            </div>

                                            <div class="col-xl-3 col-xs-10 col-md-5 col-lg-5" v-if="$router.currentRoute.name == 'EditarUsuariosGeral' || $router.currentRoute.name == 'CadastrarUsuariosGeral'">
                                                <div class="submit-field">
                                                    <h5>Tipo:</h5>
                                                    <select class="with-border" v-model="form.tipo">
                                                        <option value="" disabled selected hidden>Selecione aqui..</option>
                                                        <option value="admin">Administrador</option>
                                                        <option value="prestador">Usuário de Filial</option>
                                                        <option value="gerencial">Gerencial</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div class="col-xl-3 col-xs-10 col-md-5" v-bind:class="{'disabled': form.tipo != 'prestador'}" v-if="$router.currentRoute.name == 'EditarUsuariosGeral' || $router.currentRoute.name == 'CadastrarUsuariosGeral'">
                                                <div class="submit-field">
                                                    <h5>Filial:</h5>
                                                    <select class="with-border" v-model="form.empresaCod">
                                                        <option value="" disabled selected hidden>Selecione aqui..</option>
                                                        <option v-for="item in empresas.itens" :value="item.cod">{{item.nome}}</option>
                                                    </select>
                                                </div>
                                            </div>                                            
                                            
                                            <div class="col-xl-4 col-xs-10 col-lg-4 col-md-4" v-if="$router.currentRoute.name == 'EditarUsuariosContratante' || $router.currentRoute.name == 'CadastrarUsuariosContratante'">
                                                <div class="submit-field">
                                                    <h5>CPF:</h5>
                                                    <the-mask :mask="['###.###.###-##']" class="with-border" type="tel" v-model="form.doc" placeholder="000.000.000-00" />
                                                </div>
                                            </div>

                                            <div class="col-xl-4 col-xs-10 col-md-4 col-lg-4" v-if="$router.currentRoute.name == 'EditarUsuariosContratante' || $router.currentRoute.name == 'CadastrarUsuariosContratante'">
                                                <div class="submit-field">
                                                    <h5>Data de nascimento:</h5>
                                                    <the-mask :mask="['##/##/####']" :masked="true" type="tel" class="with-border" v-model="form.dataNascimento" placeholder="___ /____ /_____" />
                                                </div>
                                            </div>                                            

                                            <div class="col-xl-12 clearfix"></div>


                                            <!-- Button -->
                                            <div class="col-xl-12 margin-bottom-30">
                                                <small class="help" v-show="$router.currentRoute.name == 'CadastrarUsuariosContratante' || $router.currentRoute.name == 'CadastrarUsuariosGeral'">Após o cadastro, o usuário receberá no e-mail acima uma senha de acesso gerada pelo sistema.</small>
                                                <button type="submit" class="button big block-mobile" v-bind:class="{'disabled': loading.submit }">
                                                    <i class="material-icons">save</i>
                                                    Salvar alterações
                                                </button>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name: 'GerenciarUsuarios',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    data () {
        var self                    = this;
        return {
            "loading": {
                "submit":           false
            },
            "empresas": {
                "itens":            []
            },
            "form": {
                "_cod":             "",
                "_token":           "",
                "nome":             "",
                "tipo":             "",
                "email":            "",
                "telefone":         "",
                "empresaCod":       "",
                "dataNascimento":   "",
                "doc":              ""
            }            
        }
    },
    methods: {
        submit: function(e) {
            var self            = this;
            self.form._cod      = self.$root.user.cod;
            self.form._token    = self.$root.user.token;
            console.log("submit()", e, self.form, JSON.stringify(self.form));
            e.preventDefault();
            self.loading.submit = true;
            loading.show();
                
            var a = "post";
            if (self.form.cod) {
                a = "put";
            }

            console.log("acao", a);

            axios[a]("api/usuarios.php", self.form)
            .then(response => {
                
                self.loading.submit = false;
                console.log("submit() response", response)
                loading.hide();
                alert(response.data.message);
                self.$root.tmp  = {
                    "tipo":     "GerenciarUsuarios",
                    "valor":    response.data.result
                };
                self.$root.back();
                
            })
            .catch(error => {
                console.log("submit() error", error)
                loading.hide();
                self.loading.submit = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },
        getEmpresas: function() {
            var self        = this;
            console.log("getEmpresas()");
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "db":               "empresas",
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token
                    }
                };

                axios.get("api/empresas.php", form)
                .then(response => {
                    
                    console.log("getEmpresas() response", response);
                    self.empresas       = response.data.result;
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getEmpresas() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        },
        getDB: function() {
            console.log("getDB()");
            var self = this;
            return new Promise(function(resolve, reject) {
                self.$root.db["usuarios"].query(function(doc) {
                    if (doc.request.all) {
                        emit(doc);
                    }
                }, {include_docs : true}).then(function (result) {
                    console.log("usuarios find()", "ok:", result);
                    
                    var row = false;

                    result.rows.forEach(function(item) {
                        console.log("VALIDA", item);
                        if (item.doc.request.tipo == self.$router.currentRoute.meta.options.tipo) {
                            row = item;
                        }
                    })

                    var item = false;
                    if (row) {
                        console.log("Possui ROW", row);
                        item = result.rows[0].doc.result.result.itens.filter(function(item) {
                            if (item.cod == self.form.cod) return item;
                        })[0] || null;
                    }
                    
                    loading.hide();

                    if (!item) {
                        reject(false);
                        return false;
                    }

                    var d               = item.dataNascimento.split("-");
                    item.dataNascimento = d[2] + "/" + d[1] + "/" + d[0];

                    console.log("Setou usuario:", item)
                    resolve(item)

                }).catch(function (err) {
                    console.log("usuarios find()", "erro:", err);
                    resolve(err);
                });              
            });              
        },            
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                if (!self.$root.internet.online) {
                    console.log("Não está online, busca offline")
                    self.getDB().then(function(result) {
                        console.log("result", result);
                        if (result) {
                            self.form   = result;
                            self.loaded = true;
                        } else {

                        }
                    }).catch(function(error) {
                        console.log("catch", error);
                    });

                } else {   

                    var form = {
                        "params": {
                            "_cod":         self.$root.user.cod, 
                            "_token":       self.$root.user.token,
                            "cod":          self.form.cod
                        }
                    };

                    axios.get("api/usuarios.php", form)
                    .then(response => {
                        
                        console.log("get() response", response);

                        var d               = response.data.result.dataNascimento.split("-");
                        response.data.result.dataNascimento = d[2] + "/" + d[1] + "/" + d[0];
                        self.form           = response.data.result;
                        self.loaded         = true;
                        loading.hide();
                        resolve(response.data.result);
      
                    })
                    .catch(error => {
                        console.log("get() error", error);                    
                        loading.hide();
                        reject(error);
                        alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                        if (error.response) {
                            if (error.response.status == 404) {
                                self.$root.back();
                            }
                        }                    
                    });
                }   
            });   
        }
    },    
    created: function() {
        var self = this;
        console.log("created", self);

        if (self.$route.name == "EditarUsuariosGeral" || self.$route.name == "EditarUsuariosContratante") {
            if (!self.$route.query.c) {
                self.$root.back();
                return false;
            }
            self.form.cod = self.$route.query.c;
            self.get();
        } else {
            loading.hide();
        }

        if (self.$route.name == "CadastrarUsuariosContratante") {
            self.form.tipo  = "contratante";
        }
        if (self.$route.name == "CadastrarUsuariosGeral" || self.$route.name == "EditarUsuariosGeral") {
            self.getEmpresas();
        }
    },
    mounted: function() {
    }     
} 
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/GerenciarUsuarios.vue